import { Component, OnInit, Optional, ChangeDetectionStrategy } from '@angular/core';
import { AlertService, AlertType } from '../../services/alert.service';
import { ReportModalComponent } from '../report-modal/report-modal.component';
import { ActiveMedicationStockReportRequest } from '../../services/requests/Report/active-medication-stock-report.request';
import { MedicineGroupTypeStruct } from '../../services/structs/pharmacy/medicine-group-type.struct';
import { MedicineSubgroupStruct } from '../../services/structs/pharmacy/medicine-subgroup.struct';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PharmacyService } from '../../services/API/orchestrator-patient/pharmacy.service';
import { MedicineGroupService } from '../../services/API/pharmacy/medicine-group.service';
import { MedicineSubgroupService } from '../../services/API/pharmacy/medicine-subgroup.service';
import { PharmacyMovementService } from '../../services/API/pharmacy/pharmacy-movement.service';
import { ActiveMedicationStockStruct } from '../../services/structs/pharmacy/active-medication-stock.struct';
import { MenuModuleEnum } from '../menu/menu.module.enum';
import { PharmacyProductTypeEnum } from '../../enum/pharmacy/pharmacy-product-type.enum';
import { MeasurementUnit } from '../../services/models/pharmacy/measurement-unit.model';

@Component({
    selector: 'app-active-medication-stock',
    templateUrl: './active-medication-stock.component.html',
    styleUrls: ['./active-medication-stock.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ActiveMedicationStockComponent implements OnInit {

  menuModuleEnum: MenuModuleEnum = MenuModuleEnum.pharmacy;

  isModal: boolean = false;

  constructor(private alertService: AlertService,
    private medicineGroupService: MedicineGroupService,
    private medicineSubgroupService: MedicineSubgroupService,
    private pharmacyMovementService: PharmacyMovementService,
    private pharmacyService: PharmacyService,
    private dialog: MatDialog,
    @Optional() public dialogRef: MatDialogRef<ActiveMedicationStockComponent>
  ) {
    this.isModal = !!dialogRef;
  }

  public pharmacyProductTypeEnum: typeof PharmacyProductTypeEnum = PharmacyProductTypeEnum;

  pageSize: number = 50;
  pageIndex: number = 0;
  fullSize: number = null;
  asyncCallsCounter: number = 0;
  totalStock: number = 0;

  isLoading: boolean = true;
  isFirstLoading: boolean = true;
  isPrintTableLoading: boolean = false;

  searchText: string = null;
  totalValueInStock: string = 'R$ 0';

  productType: number = this.pharmacyProductTypeEnum.Todos;
  listIdMedicineGroup: number[] = [];
  listIdMedicineSubGroup: number[] = [];
  listGroupStruct: MedicineGroupTypeStruct[];
  listSubgroupStruct: MedicineSubgroupStruct[];
  listActiveMedicationStockStruct: ActiveMedicationStockStruct[] = [];

  listMeasurementUnit: MeasurementUnit[] = [];
  columns: { header: string, field: string, isAction?: boolean, width?: string }[] = [
    { header: 'Medicamento/Material', field: 'descriptionName', width: '40%' },
    { header: 'Unidade', field: 'measurementUnitName', width: '20%' },
    { header: 'Apresentação', field: 'medicinePresentationTypeName', width: '20%' },
    { header: 'Qtd. em estoque', field: 'totalStock', width: '10%' },
    { header: 'Total R$ em estoque', field: 'totalValueInStock', width: '10%' },
  ];

  ngOnInit(): void {
    this.isModal = this.dialogRef ? true : false;

    let asyncCallsCounter: number = 0;

    const handleAsyncCallCompleted = () => {
      asyncCallsCounter++;
      if (asyncCallsCounter === 2) {
        this.isFirstLoading = false;
        this.search();
      }
    };

    this.populateGroup(handleAsyncCallCompleted);
    this.populateSubgroup(handleAsyncCallCompleted);
  }

  private timeoutKeySearch: any = null;
  onKeySearch(event: any) {
    clearTimeout(this.timeoutKeySearch);
    var $this = this;
    this.timeoutKeySearch = setTimeout(function () {
      if (event.keyCode != 13) {
        $this.pageIndex = 0;
        $this.search();
      }
    }, 1000);
  }

  changePage(pageIndex: number) {
    this.pageIndex = pageIndex;
    this.search();
  }

  search() {
    this.isLoading = true;
    this.pharmacyMovementService.getAllMedicinePaginated(this.searchText, this.pageIndex, this.productType, this.listIdMedicineSubGroup, this.listIdMedicineGroup).subscribe({
      next: (response) => {
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          this.isLoading = false;
          return;
        }
        this.listActiveMedicationStockStruct = [];
        if (response) {
          this.listMeasurementUnit = response.listMeasurementUnit;
          if (response.listActiveMedicationStockStruct && response.listActiveMedicationStockStruct.length > 0) {
            this.listActiveMedicationStockStruct = response.listActiveMedicationStockStruct;

            this.listActiveMedicationStockStruct.forEach(x => {
              if (x.idMeasurementUnit)
                x.measurementUnitName = this.listMeasurementUnit.find(measure => measure.idMeasurementUnit == x.idMeasurementUnit)?.measurementUnitName;
            });
          }

          this.fullSize = response.fullSize;
          this.totalStock = response.totalStock;
          this.totalValueInStock = response.totalValueInStock;
        }

        this.isLoading = false;
      },
      error: (error) => {
        console.log(error);
        this.isLoading = false;
        this.alertService.show('Erro inesperado', error, AlertType.error);
      }
    });
  }

  populateGroup(callback: () => void) {
    this.medicineGroupService.listAllMedicineGroup().subscribe({
      next: (response) => {
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          this.isFirstLoading = false;
          return;
        }

        this.listGroupStruct = response.listMedicineGroupTypeStruct;

        callback();
      },
      error: (error) => {
        console.log(error);
        this.isFirstLoading = false;
        this.alertService.show('Erro inesperado', error, AlertType.error);
      }
    });
  }

  populateSubgroup(callback: () => void) {
    this.medicineSubgroupService.listAllMedicineSubgroup().subscribe({
      next: (response) => {
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          this.isFirstLoading = false;
          return;
        }

        this.listSubgroupStruct = response.listMedicineSubgroupStruct;

        callback();
      },
      error: (error) => {
        console.log(error);
        this.isFirstLoading = false;
        this.alertService.show('Erro inesperado', error, AlertType.error);
      }
    });
  }

  getListNoPaginated() {
    this.isPrintTableLoading = true;

    this.pharmacyMovementService.getAllMedicineNoPaginated(this.searchText, this.productType, this.listIdMedicineSubGroup, this.listIdMedicineGroup).subscribe({
      next: (response) => {
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          this.isPrintTableLoading = false;
          return;
        }
        if (response) {
          this.listMeasurementUnit = response.listMeasurementUnit;

          if (response.listActiveMedicationStockStruct && response.listActiveMedicationStockStruct.length > 0) {
            let listActiveMedicationStockStruct = [...response.listActiveMedicationStockStruct];

            listActiveMedicationStockStruct.forEach(x => {
              if (x.idMeasurementUnit)
                x.measurementUnitName = this.listMeasurementUnit?.find(measure => measure.idMeasurementUnit == x.idMeasurementUnit)?.measurementUnitName;
            });

            let reportRequest = new ActiveMedicationStockReportRequest();
            reportRequest.listActiveMedicationStockStruct = listActiveMedicationStockStruct;
            reportRequest.totalStock = response.totalStock;
            reportRequest.totalValueInStock = response.totalValueInStock;
            this.printTable(reportRequest);
          }
        }
        else
          this.isPrintTableLoading = false;
      },
      error: (error) => {
        console.log(error);
        this.isPrintTableLoading = false;
        this.alertService.show('Erro inesperado', error, AlertType.error);
      }
    });
  }

  printTable(reportRequest: ActiveMedicationStockReportRequest) {
    this.pharmacyService.getReport(reportRequest).subscribe({
      next: (response) => {
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          this.isPrintTableLoading = false;
          return;
        }

        this.dialog.open(ReportModalComponent, {
          data: {
            reportPdf64: response.reportPdf64,
          },
        });

        this.isPrintTableLoading = false;
      },
      error: (error) => {
        console.log(error);
        this.isPrintTableLoading = false;
        this.alertService.show('Erro inesperado', error, AlertType.error);
      }
    });
  }

  closeDialog() {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }
}